import { useState } from 'react';
import useDeleteSpaceMember from '../../api/useDeleteSpaceMember';
import type { SpaceMemberWithProfile } from '../../types';

type Props = {
  spaceId: string;
  member: SpaceMemberWithProfile;
};

export default function useMemberMenuAction(props: Props) {
  const deleteMember = useDeleteSpaceMember();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  function handleOpenEditModal() {
    setIsEditModalOpen(true);
  }

  function handleCloseEditModal() {
    setIsEditModalOpen(false);
  }

  function handleOpenRemoveModal() {
    setIsRemoveModalOpen(true);
  }

  function handleCloseRemoveModal() {
    setIsRemoveModalOpen(false);
  }

  function handleConfirmRemove() {
    return deleteMember.mutateAsync({ memberId: props.member.id, spaceId: props.spaceId });
  }

  return {
    isEditModalOpen,
    isRemoveModalOpen,
    handleOpenEditModal,
    handleCloseEditModal,
    handleOpenRemoveModal,
    handleCloseRemoveModal,
    handleConfirmRemove,
  };
}
